// extracted by mini-css-extract-plugin
module.exports = {"title":"modal_title__x-izx","subtitle":"modal_subtitle__2KBQ9"};